import React, {memo, useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import { translate } from '../../common/translation/translate';
import { Checkbox } from '../common/utilities/checkBox';
import * as Containers from './uninstallCommonComponents';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';

const OPTIONS = [
    translate('moreFeatures'), 
    translate('notLikeFeel'), 
    translate('wrongInfo'), 
    translate('longLoadTime'),
    translate('iComputerDummy')
];

export const UninstallFormView = memo(({
    handleCheckboxChange, 
    handleOtherTextChange,
    handleEmailChange,
    handleFormSubmit,
    checkboxStates,
    submitted
}) => {
    if (submitted) {
        return (
            <Containers.Title>
                {translate('thanksForHelping')}
            </Containers.Title> 
        )
    }
    return(
        <>
            <Containers.Title>
                { translate('seeYouGo') }  
            </Containers.Title>
            <Containers.SubTitle>
                { translate('haveAMoment') }
            </Containers.SubTitle>
            <form onSubmit={handleFormSubmit}>
                <Containers.FormBody>
                    {OPTIONS.map(option => (
                        <Checkbox
                            label={option}
                            checked={ checkboxStates[option] || false }
                            name={option}
                            onChange={handleCheckboxChange}
                            key={option}
                        />
                    ))}
                    <Containers.OtherBox>
                        <Containers.FormLabel> 
                            <Containers.TopLabel> { translate('other') } </Containers.TopLabel>
                            <Containers.OtherTextbox onChange={handleOtherTextChange} name='other'  />
                        </Containers.FormLabel>  
                    </Containers.OtherBox> 
                </Containers.FormBody>
                <Containers.FormLabel> 
                    <Containers.TopLabel> { translate('yourEmail') } </Containers.TopLabel>
                    <Containers.EmailTextBox onChange={handleEmailChange} placeholder='Your-email@example.com' name='email'/>
                </Containers.FormLabel>
                <Containers.FormSubmitButton>
                    { translate('submit') }
                </Containers.FormSubmitButton>
            </form>
        </>
    );
});

UninstallFormView.displayName = 'UninstallFormView';
UninstallFormView.propTypes = {
    handleCheckboxChange: PropTypes.func, 
    handleOtherTextChange: PropTypes.func,
    handleEmailChange: PropTypes.func,
    handleFormSubmit: PropTypes.func,
    checkboxStates: PropTypes.object,
    submitted: PropTypes.bool
};
